import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import arAlerts from './assets/locales/ar/alerts.json';
import arChargingSession from './assets/locales/ar/chargingSession.json';
import arCustomTable from './assets/locales/ar/customTable.json';
import arDashboard from './assets/locales/ar/dashboard.json';
import arDelete from './assets/locales/ar/delete.json';
import arDeviceManagement from './assets/locales/ar/deviceManagement.json';
import arDynamicPricing from './assets/locales/ar/dynamicPricing.json';
import arFacilityManagement from './assets/locales/ar/facilityManagement.json';
import arGuestCharging from './assets/locales/ar/guestCharging.json';
import arHeader from './assets/locales/ar/header.json';
import arLogin from './assets/locales/ar/login.json';
import arLoginV2 from './assets/locales/ar/loginV2.json';
import arMaintenanceSchedule from './assets/locales/ar/maintenanceSchedule.json';
import arPenaltyManagement from './assets/locales/ar/penaltyManagement.json';
import arProfile from './assets/locales/ar/profile.json';
import arReports from './assets/locales/ar/reports.json';
import arScheduleManagement from './assets/locales/ar/scheduleManagement.json';
import arSetting from './assets/locales/ar/setting.json';
import arSharedComp from './assets/locales/ar/sharedComp.json';
import arStation from './assets/locales/ar/station.json';
import arStationManagement from './assets/locales/ar/stationManagement.json';
import arTableSidepanel from './assets/locales/ar/tableSidepanel.json';
import arTransactionManagement from './assets/locales/ar/transactionManagement.json';
import arUserManagement from './assets/locales/ar/userManagement.json';
import arVLBC from './assets/locales/ar/vlbc.json';
import enAlerts from './assets/locales/en/alerts.json';
import enChargingSession from './assets/locales/en/chargingSession.json';
import enCustomTable from './assets/locales/en/customTable.json';
import enDashboard from './assets/locales/en/dashboard.json';
import enDelete from './assets/locales/en/delete.json';
import enDeviceManagement from './assets/locales/en/deviceManagement.json';
import enDynamicPricing from './assets/locales/en/dynamicPricing.json';
import enFacilityManagement from './assets/locales/en/facilityManagement.json';
import enGuestCharging from './assets/locales/en/guestCharging.json';
import enHeader from './assets/locales/en/header.json';
import enLogin from './assets/locales/en/login.json';
import enLoginV2 from './assets/locales/en/loginV2.json';
import enMaintenanceSchedule from './assets/locales/en/maintenanceSchedule.json';
import enPenaltyManagement from './assets/locales/en/penaltyManagement.json';
import enProfile from './assets/locales/en/profile.json';
import enReports from './assets/locales/en/reports.json';
import enScheduleManagement from './assets/locales/en/scheduleManagement.json';
import enSetting from './assets/locales/en/setting.json';
import enSharedComp from './assets/locales/en/sharedComp.json';
import enStation from './assets/locales/en/station.json';
import enStationManagement from './assets/locales/en/stationManagement.json';
import enTableSidepanel from './assets/locales/en/tableSidepanel.json';
import enTransactionManagement from './assets/locales/en/transactionManagement.json';
import enUserManagement from './assets/locales/en/userManagement.json';
import enVLBC from './assets/locales/en/vlbc.json';
import frAlerts from './assets/locales/fr/alerts.json';
import frChargingSession from './assets/locales/fr/chargingSession.json';
import frCustomTable from './assets/locales/fr/customTable.json';
import frDashboard from './assets/locales/fr/dashboard.json';
import frDelete from './assets/locales/fr/delete.json';
import frDeviceManagement from './assets/locales/fr/deviceManagement.json';
import frDynamicPricing from './assets/locales/fr/dynamicPricing.json';
import frFacilityManagement from './assets/locales/fr/facilityManagement.json';
import frGuestCharging from './assets/locales/fr/guestCharging.json';
import frHeader from './assets/locales/fr/header.json';
import frLogin from './assets/locales/fr/login.json';
import frLoginV2 from './assets/locales/fr/loginV2.json';
import frMaintenanceSchedule from './assets/locales/fr/maintenanceSchedule.json';
import frPenaltyManagement from './assets/locales/fr/penaltyManagement.json';
import frProfile from './assets/locales/fr/profile.json';
import frReports from './assets/locales/fr/reports.json';
import frScheduleManagement from './assets/locales/fr/scheduleManagement.json';
import frSetting from './assets/locales/fr/setting.json';
import frSharedComp from './assets/locales/fr/sharedComp.json';
import frStation from './assets/locales/fr/station.json';
import frStationManagement from './assets/locales/fr/stationManagement.json';
import frTableSidepanel from './assets/locales/fr/tableSidepanel.json';
import frTransactionManagement from './assets/locales/fr/transactionManagement.json';
import frUserManagement from './assets/locales/fr/userManagement.json';
import frVLBC from './assets/locales/fr/vlbc.json';
import spAlerts from './assets/locales/sp/alerts.json';
import spChargingSession from './assets/locales/sp/chargingSession.json';
import spCustomTable from './assets/locales/sp/customTable.json';
import spDashboard from './assets/locales/sp/dashboard.json';
import spDelete from './assets/locales/sp/delete.json';
import spDeviceManagement from './assets/locales/sp/deviceManagement.json';
import spDynamicPricing from './assets/locales/sp/dynamicPricing.json';
import spFacilityManagement from './assets/locales/sp/facilityManagement.json';
import spGuestCharging from './assets/locales/sp/guestCharging.json';
import spHeader from './assets/locales/sp/header.json';
import spLogin from './assets/locales/sp/login.json';
import spLoginV2 from './assets/locales/sp/loginV2.json';
import spMaintenanceSchedule from './assets/locales/sp/maintenanceSchedule.json';
import spPenaltyManagement from './assets/locales/sp/penaltyManagement.json';
import spProfile from './assets/locales/sp/profile.json';
import spReports from './assets/locales/sp/reports.json';
import spScheduleManagement from './assets/locales/sp/scheduleManagement.json';
import spSetting from './assets/locales/sp/setting.json';
import spSharedComp from './assets/locales/sp/sharedComp.json';
import spStation from './assets/locales/sp/station.json';
import spStationManagement from './assets/locales/sp/stationManagement.json';
import spTableSidepanel from './assets/locales/sp/tableSidepanel.json';
import spTransactionManagement from './assets/locales/sp/transactionManagement.json';
import spUserManagement from './assets/locales/sp/userManagement.json';
import spVLBC from './assets/locales/sp/vlbc.json';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        login: enLogin,
        station: enStation,
        dashboard: enDashboard,
        vlbc: enVLBC,
        reports: enReports,
        maintenanceSchedule: enMaintenanceSchedule,
        deviceManagement: enDeviceManagement,
        stationManagement: enStationManagement,
        facilityManagement: enFacilityManagement,
        dynamicPricing: enDynamicPricing,
        userManagement: enUserManagement,
        guestCharging: enGuestCharging,
        transactionManagement: enTransactionManagement,
        chargingSession: enChargingSession,
        scheduleManagement: enScheduleManagement,
        header: enHeader,
        profile: enProfile,
        tableSidepanel: enTableSidepanel,
        customTable: enCustomTable,
        delete: enDelete,
        sharedComp: enSharedComp,
        setting: enSetting,
        alerts: enAlerts,
        penaltyManagement: enPenaltyManagement,
        loginV2: enLoginV2,
      },
      fr: {
        login: frLogin,
        station: frStation,
        dashboard: frDashboard,
        vlbc: frVLBC,
        reports: frReports,
        maintenanceSchedule: frMaintenanceSchedule,
        deviceManagement: frDeviceManagement,
        stationManagement: frStationManagement,
        facilityManagement: frFacilityManagement,
        dynamicPricing: frDynamicPricing,
        userManagement: frUserManagement,
        guestCharging: frGuestCharging,
        transactionManagement: frTransactionManagement,
        chargingSession: frChargingSession,
        scheduleManagement: frScheduleManagement,
        header: frHeader,
        profile: frProfile,
        tableSidepanel: frTableSidepanel,
        customTable: frCustomTable,
        delete: frDelete,
        sharedComp: frSharedComp,
        setting: frSetting,
        alerts: frAlerts,
        penaltyManagement: frPenaltyManagement,
        loginV2: frLoginV2,
      },
      ar: {
        login: arLogin,
        station: arStation,
        dashboard: arDashboard,
        vlbc: arVLBC,
        reports: arReports,
        maintenanceSchedule: arMaintenanceSchedule,
        deviceManagement: arDeviceManagement,
        stationManagement: arStationManagement,
        facilityManagement: arFacilityManagement,
        dynamicPricing: arDynamicPricing,
        userManagement: arUserManagement,
        guestCharging: arGuestCharging,
        transactionManagement: arTransactionManagement,
        chargingSession: arChargingSession,
        scheduleManagement: arScheduleManagement,
        header: arHeader,
        profile: arProfile,
        tableSidepanel: arTableSidepanel,
        customTable: arCustomTable,
        delete: arDelete,
        sharedComp: arSharedComp,
        setting: arSetting,
        alerts: arAlerts,
        penaltyManagement: arPenaltyManagement,
        loginV2: arLoginV2,
      },
      sp: {
        login: spLogin,
        station: spStation,
        dashboard: spDashboard,
        vlbc: spVLBC,
        reports: spReports,
        maintenanceSchedule: spMaintenanceSchedule,
        deviceManagement: spDeviceManagement,
        stationManagement: spStationManagement,
        facilityManagement: spFacilityManagement,
        dynamicPricing: spDynamicPricing,
        userManagement: spUserManagement,
        guestCharging: spGuestCharging,
        transactionManagement: spTransactionManagement,
        chargingSession: spChargingSession,
        scheduleManagement: spScheduleManagement,
        header: spHeader,
        profile: spProfile,
        tableSidepanel: spTableSidepanel,
        customTable: spCustomTable,
        delete: spDelete,
        sharedComp: spSharedComp,
        setting: spSetting,
        alerts: spAlerts,
        penaltyManagement: spPenaltyManagement,
        loginV2: spLoginV2,
      },
    },

    supportedLngs: ['en', 'ar', 'fr', 'sp'],
    fallbackLng: 'en',
    detection: {
      order: [
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['cookie'],

      // keys or params to lookup language from
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
    },
    ns: [
      'common',
      'login',
      'station',
      'dashboard',
      'deviceManagement',
      'vlbc',
      'reports',
      'maintenanceSchedule',
      'stationManagement',
      'facilityManagement',
      'dynamicPricing',
      'userManagement',
      'guestCharging',
      'transactionManagement',
      'chargingSession',
      'scheduleManagement',
      'header',
      'profile',
      'tableSidepanel',
      'customTable',
      'delete',
      'sharedComp',
      'delete',
      'sharedComp',
      'setting',
      'alerts',
      'penaltyManagement',
      'loginV2',
    ],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
